import axios from 'axios'
import config from '@/config'

const actions = {
  GET_MEETING_DETAILS({rootGetters}, meetingId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'meeting/details/' + meetingId, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  GET_MEETING_QUESTION_RESULT({rootGetters}, questionId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'question/result/' + questionId, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  SAVE_MEETING({rootGetters}, meeting) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.APi_URL + 'meeting/save', meeting, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  REPORT_MEETING_QUESTIONNAIRE({rootGetters}, meeting) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          config.APi_URL +
            `meeting/report/questionnaire/?meetingId=${meeting.id}${
              meeting.apartmentId ? '&apartmentId=' + meeting.apartmentId : ''
            }${meeting.deliveryAddress ? '&deliveryAddress=' + meeting.deliveryAddress : ''}${
              meeting.reportType ? '&reportType=' + meeting.reportType : ''
            }`,
          {headers: rootGetters.getRequestConfig.headers, responseType: 'blob'}
        )
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  REPORT_MEETING_ADVANCE({rootGetters}, meetingId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + `meeting/report/advance/?meetingId=${meetingId}`, {
          headers: rootGetters.getRequestConfig.headers,
          responseType: 'blob'
        })
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  REPORT_MEETING_PROTOCOL({rootGetters}, meeting) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          config.APi_URL +
            `meeting/report/protocol/?meetingId=${meeting.id}&address=${meeting.address}&communityMembers=${meeting.communityMembers}`,
          {headers: rootGetters.getRequestConfig.headers, responseType: 'blob'}
        )
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  PUBLISHING_MEETING({rootGetters}, meetingId) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          config.APi_URL + 'meeting/publish/' + meetingId,
          false,
          rootGetters.getRequestConfigPut
        )
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default {
  namespaced: true,
  actions
}
